<template>
	<div :class="containerClass" @click="onDocumentClick">

		<AppTopbar
ref="apptopbar" :show-icons="true" :topbar-menu-active="topbarMenuActive"
			:active-topbar-item="activeTopbarItem" :inline-user="inlineUser" @right-menubutton-click="onRightMenuButtonClick"
			@menubutton-click="onMenuButtonClick" @topbar-menubutton-click="onTopbarMenuButtonClick"
			@topbar-item-click="onTopbarItemClick" @logout-button-click="onLogout" />

		<!-- <div class="logout-modal" v-if="showLogoutModal">
      <LogoutConfirmation :display="true" @cancel-logout="onCancelLogout" @confirm-logout="onConfirmLogout" />
    </div> -->


		<AppRightMenu :right-panel-menu-active="rightPanelMenuActive" @rightmenu-click="onRightMenuClick" />

		<!--
			Botão flutuante para reabrir o menu quando ele está recolhido.
			O recolher fica no cabeçalho do próprio menu (não no top bar).
		-->
		<button
			v-if="!isMenuVisible()"
			type="button"
			class="menu-toggle-reabrir"
			aria-label="Mostrar menu"
			title="Mostrar menu"
			@click="onMenuButtonClick"
		>
			<i class="pi pi-angle-right" aria-hidden="true" />
		</button>

		<transition name="layout-menu-container">
			<div v-show="isMenuVisible()" class="layout-menu-container" @click="onMenuClick">
				<header class="menu-cabecalho">
					<span class="menu-cabecalho-titulo">Menu</span>
					<button
						type="button"
						class="menu-cabecalho-recolher"
						aria-label="Esconder menu"
						title="Esconder menu"
						@click.stop="onMenuButtonClick"
					>
						<i class="pi pi-angle-left" aria-hidden="true" />
					</button>
				</header>

				<!-- Pesquisa de rotinas: filtra o menu lateral (R3Input + lupa). -->
				<div
					class="menu-pesquisa"
					@click.stop
					@mousedown.stop
				>
					<R3Input
						v-model="menuPesquisa"
						input-id="menu-pesquisa-rotina"
						class="menu-pesquisa-input"
						placeholder="Pesquisar rotina..."
						icon="pi-search"
						:right-button-visible="true"
						mode="search"
					/>
				</div>

				<div class="menu-scroll-content">
					<div v-if="inlineUser" class="layout-profile">
						<button class="p-link layout-profile-button" @click="onInlineUserClick">
							<img src="~/assets/images/avatar.jpg" alt="roma-layout">
							<span class="layout-profile-userinfo">
								<span class="layout-profile-name">{{ displayName || "—" }}</span>
							</span>
						</button>
						<transition name="layout-profile-menu">
							<ul
v-show="inlineUserMenuActive"
								:class="['layout-profile-menu', { 'profile-menu-active': inlineUserMenuActive }]">
								<li>
									<button class="p-link"><i class="pi pi-fw pi-user" /><span>Profile</span></button>
								</li>
								<li>
									<button class="p-link"><i class="pi pi-fw pi-cog" /><span>Settings</span></button>
								</li>
								<li>
									<button class="p-link"><i class="pi pi-fw pi-envelope" /><span>Messages</span></button>
								</li>
								<li>
									<button class="p-link"><i class="pi pi-fw pi-bell" /><span>Notifications</span></button>
								</li>
							</ul>
						</transition>
					</div>
					<p
						v-if="menuPesquisa.trim() && menuLateralFiltrado.length === 0"
						class="menu-pesquisa-vazio"
					>
						Nenhuma rotina encontrada.
					</p>
					<AppMenu
						:model="menuLateralFiltrado"
						:layout-mode="layoutMode"
						:active="menuActive"
						:mobile-menu-active="staticMenuMobileActive"
						@menuitem-click="onMenuItemClick"
						@root-menuitem-click="onRootMenuItemClick"
					/>
				</div>
			</div>
		</transition>

		<div class="layout-main" style="padding-top: 56px;">

			<div class="layout-content">
				<!-- Abas: cada opção do menu lateral abre no centro. -->
				<DesktopTabs />
				<slot />
			</div>

			<!-- <AppConfig :layoutMode="layoutMode" @layout-change="onLayoutChange" :lightMenu="lightMenu"
        @menu-color-change="onMenuColorChange" :inlineUser="inlineUser" @profile-mode-change="onProfileModeChange"
        :isRTL="isRTL" @orientation-change="onChangeOrientation" :topbarColor="topbarColor" :topbarColors="topbarColors"
        @topbar-color-change="onTopbarColorChange" :theme="theme" :themes="themeColors" @theme-change="onThemeChange">
      </AppConfig> -->

			<!-- Rodapé ROMA removido: template do tema, não faz parte do Harpia. -->
		</div>

		<div class="layout-content-mask" />
	</div>
</template>


<script lang="ts" setup>
// import { useToast } from 'primevue/usetoast';
// import { usePrimeVue } from "primevue/config";
import { useNuxtApp } from "#app";
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';

import { menuCollector, menuStation } from "~/data";

import type { PagesMenu } from '../types/pagesMenu';
import { useUsuarioLogadoDisplay } from "~/composables/useUsuarioLogadoDisplay";
import DesktopTabs from "~/components/dashboard/DesktopTabs.vue";
import { useDesktopTabsStore } from "~/store/tabs/desktopTabs.store";
import useSetMenusStation from "~/composables/useSetMenusStation";


// watches

const apptopbar = ref();
// stores
const pageStore = usePageStore()
const allowedMenusStore = useAllowedMenus()
const tabsStore = useDesktopTabsStore();
const userStore = useUserStore();
const { layout } = storeToRefs(pageStore)
// Nome no menu lateral (só aparece se inlineUser=true; topbar usa o mesmo composable)
const { displayName } = useUsuarioLogadoDisplay();

/**
 * Menu lateral: desktop usa catálogo filtrado por permissão (allowedMenus).
 * Coletor continua com menuCollector / userRoutines.
 */
const menuLateralModel = computed((): PagesMenu[] => {
	if (pageStore.isCollector() === true) {
		const rotinas = userStore.userRoutines as PagesMenu[] | undefined;
		if (rotinas?.some(m => (m.items?.length ?? 0) > 0)) return rotinas;
		return menuCollector as PagesMenu[];
	}
	// Desktop: só o que passou por useSetMenusStation (sem permissão = não lista).
	if (allowedMenusStore.menus?.length) {
		return allowedMenusStore.menus as PagesMenu[];
	}
	// Enquanto carrega: só o painel operacional (fail-closed).
	return [
		{
			label: "Início",
			icon: "pi pi-fw pi-home",
			items: [
				{
					label: "Painel operacional",
					icon: "pi pi-fw pi-home",
					to: "/",
					nome: "Home" as any,
					visible: true,
				},
			],
		},
	];
});

/** Texto da pesquisa no topo do menu de rotinas. */
const menuPesquisa = ref("");

/**
 * Aplica o filtro digitado sobre o menu já autorizado (label, código, path, nome).
 * Grupos sem item correspondente somem.
 */
const menuLateralFiltrado = computed((): PagesMenu[] => {
	const base = menuLateralModel.value;
	const q = menuPesquisa.value.trim().toLowerCase();
	if (!q) return base;

	const resultado: PagesMenu[] = [];
	for (const grupo of base) {
		const itens = (grupo.items ?? []).filter((item) => {
			const label = String(item.label ?? "").toLowerCase();
			const to = String(item.to ?? "").toLowerCase();
			const nome = String((item as { nome?: string }).nome ?? "").toLowerCase();
			return label.includes(q) || to.includes(q) || nome.includes(q);
		});
		if (itens.length === 0) continue;
		resultado.push({ ...grupo, items: itens });
	}
	return resultado;
});


const route = useRoute();
const isLoading = ref(true)
console.log(isLoading)

const toast = useToast()
const primeVue = usePrimeVue()
const { $eventBus } = useNuxtApp()

/** Busca o rótulo da rotina no menu lateral (ou no atalho do dashboard). */
function rotuloDaRota(path: string): string | undefined {
	const p = tabsStore.normalizarPath(path);
	// Preferir menu autorizado (desktop); catálogo completo só para resolver rótulo de atalho.
	const menus: PagesMenu[] = [
		...menuLateralModel.value,
		...(pageStore.isCollector() ? [] : (menuStation as PagesMenu[])),
	];
	for (const grupo of menus) {
		for (const item of grupo.items ?? []) {
			if (item.to && tabsStore.normalizarPath(String(item.to)) === p) {
				return item.label;
			}
		}
	}
	// Atalhos do painel operacional (fora do menuStation).
	const atalhos: Record<string, string> = {
		"/": "Painel operacional",
		"/averiguacao/consolidada": "B323 — Separação consolidada",
		"/averiguacao/unidade": "3422 — Averiguação Eletrônica",
		"/monitoramento/cargas-consolidadas": "363 — Monitoramento cargas consolidadas",
		"/acompanhamento/produtividade-remuneracao": "A424 — Produtividade Separador/Conferente de Expedição",
		"/acompanhamento/produtividade-remuneracao-tv": "A424 — Produtividade (TV)",
		"/PROC_DIGITACAO_PLANILHA_CONFERENCIA_COLETOR": "B311 — Protocolos de entrada",
		"/PROC_AVERIGUACAO_PICKING_CX_COLETOR": "B321 — Averiguação de volumes",
		"/PROC_CONV_ATIVA_COL_AGENTES": "B331 — Convocação ativa",
	};
	return atalhos[p];
}

function sincronizarAbaComRota(path: string) {
	const p = tabsStore.normalizarPath(path);
	const label =
		rotuloDaRota(p)
		|| userStore.currentPageName
		|| undefined;
	tabsStore.abrir(p, label);
}

// Toda navegação (menu, atalho, digitar URL) vira/ativa aba no centro.
watch(
	() => route.fullPath,
	(fullPath) => {
		sincronizarAbaComRota(fullPath);
	},
	{ immediate: true },
);

// $enableShortcuts("f1", "f2");

const layoutMode = ref<string | undefined>('static');
const lightMenu = ref<boolean | null>(true);
const overlayMenuActive = ref(false);
const staticMenuMobileActive = ref(false);
const staticMenuDesktopInactive = ref(false);
const isRTL = ref<boolean | null>(false);
const inlineUser = ref<boolean | null>(false);
const topbarMenuActive = ref(false);
const activeTopbarItem = ref<string>("null");
const rightPanelMenuActive = ref(false);
const inlineUserMenuActive = ref(false);
const menuActive = ref(false);
const topbarColor = ref<string | null>('layout-topbar-blue');
const topbarItemClick = ref(false);
const rightMenuClick = ref(false);
const userMenuClick = ref(false);
const menuClick = ref(false);
const theme = ref<string>('blue');


const topbarColors: any[] | null = [
	{ name: 'Light', topbarColor: 'layout-topbar-light', logo: 'logo-roma', color: '#ffffff' },
	{ name: 'Dark', topbarColor: 'layout-topbar-dark', logo: 'logo-roma-white', color: '#252529' },
	{ name: 'Blue', topbarColor: 'layout-topbar-blue', logo: 'logo-roma-white', color: '#0772B3' },
	{ name: 'Green', topbarColor: 'layout-topbar-green', logo: 'logo-roma-white', color: '#0F8C50' },
	{ name: 'Orange', topbarColor: 'layout-topbar-orange', logo: 'logo-roma-white', color: '#C76D09' },
	{
		name: 'Magenta',
		topbarColor: 'layout-topbar-magenta',
		logo: 'logo-roma-white',
		color: '#972BB1',
	},
	{
		name: 'Blue Grey',
		topbarColor: 'layout-topbar-bluegrey',
		logo: 'logo-roma-white',
		color: '#406E7E',
	},
	{
		name: 'Deep Purple',
		topbarColor: 'layout-topbar-deeppurple',
		logo: 'logo-roma-white',
		color: '#543CD9',
	},
	{ name: 'Brown', topbarColor: 'layout-topbar-brown', logo: 'logo-roma-white', color: '#794F36' },
	{ name: 'Lime', topbarColor: 'layout-topbar-lime', logo: 'logo-roma-white', color: '#849201' },
	{ name: 'Rose', topbarColor: 'layout-topbar-rose', logo: 'logo-roma-white', color: '#8F3939' },
	{ name: 'Cyan', topbarColor: 'layout-topbar-cyan', logo: 'logo-roma-white', color: '#0C8990' },
	{ name: 'Teal', topbarColor: 'layout-topbar-teal', logo: 'logo-roma-white', color: '#337E59' },
	{
		name: 'Deep Orange',
		topbarColor: 'layout-topbar-deeporange',
		logo: 'logo-roma-white',
		color: '#D74A1D',
	},
	{ name: 'Indigo', topbarColor: 'layout-topbar-indigo', logo: 'logo-roma-white', color: '#3D53C9' },
	{ name: 'Pink', topbarColor: 'layout-topbar-pink', logo: 'logo-roma-white', color: '#BF275B' },
	{ name: 'Purple', topbarColor: 'layout-topbar-purple', logo: 'logo-roma-white', color: '#7F32DA' },
];

const themeColors: { name: string, file: string, color: string }[] | null = [
	{ name: 'Blue', file: 'blue', color: '#0f97c7' },
	{ name: 'Blue Grey', file: 'bluegrey', color: '#578697' },
	{ name: 'Brown', file: 'brown', color: '#97664A' },
	{ name: 'Cyan', file: 'cyan', color: '#1BA7AF' },
	{ name: 'Deep Orange', file: 'deeporange', color: '#F96F43' },
	{ name: 'Deep Purple', file: 'deeppurple', color: '#6952EC' },
	{ name: 'Green', file: 'green', color: '#10B163' },
	{ name: 'Teal', file: 'teal', color: '#4EA279' },
	{ name: 'Indigo', file: 'indigo', color: '#435AD8' },
	{ name: 'Lime', file: 'lime', color: '#A5B600' },
	{ name: 'Magenta', file: 'magenta', color: '#B944D6' },
	{ name: 'Orange', file: 'orange', color: '#E2841A' },
	{ name: 'Pink', file: 'pink', color: '#E93A76' },
	{ name: 'Purple', file: 'purple', color: '#9643F9' },
	{ name: 'Rose', file: 'rose', color: '#AB5353' },
];

watch(route, () => {
	menuActive.value = false;
	toast.removeAllGroups();
});
// watch(pageStore, (received) => {
//   if (received) {
//     definePageMeta({
//       layout: "default"
//     })
//     isLoading.value = false
//   }
// })

onBeforeMount(() => {
	// Não carregar o catálogo inteiro sem filtrar permissão (bug do 1150).
})

onMounted(() => {
	const { isMobileDevice } = useIsMobile();
	if (isMobileDevice.value) {
		// Coletor: menus já montados por useSetMenusCollector no login/index.
		return;
	}
	// Limpa cache persistido do menu sem filtro (evita 1150 “vazar” até a API responder).
	allowedMenusStore.setMenus([]);
	// Desktop: filtra menuStation por CORE_ACESSO_USUARIO do usuário logado.
	void useSetMenusStation().catch((e) => {
		console.error("[default] falha ao filtrar menu desktop:", e);
	});
})
// const showLogoutModal = ref(false)

// function onCancelLogout() {
//   showLogoutModal.value = false
// }

// function onConfirmLogout() {
//   userStore.setAuthStatus(false);
//   useDeleteCookie('accessToken');
//   showLogoutModal.value = false
//   navigateTo("/login")
// }

// async function onLogout(event: Event) {

//   showLogoutModal.value = true

//   event.preventDefault()
// }

// function redirectToLoginIfNotAuthenticated() {
//   const cookie = useCookie('accessToken').value
//   //if (!cookie) {
//   // navigateTo("/login")
//   //}

//   if (cookie) {
//     pageStore.setLayout("main")
//   }
// }


function onDocumentClick() {
	if (!topbarItemClick.value) {
		activeTopbarItem.value = "null";
		topbarMenuActive.value = false;
	}
	if (!rightMenuClick.value) {
		rightPanelMenuActive.value = false;
	}
	if (!userMenuClick.value && isSlim() && !isMobile()) {
		inlineUserMenuActive.value = false;
	}
	if (!menuClick.value) {
		if (isHorizontal() || isSlim()) {
			menuActive.value = false;
		}
		if (overlayMenuActive.value || staticMenuMobileActive) {
			hideOverlayMenu();
		}
		$eventBus.$emit('reset-active-index');
		unblockBodyScroll();
	}
	if (userMenuClick.value) {
		menuActive.value = false;
		$eventBus.$emit('reset-active-index');
	}

	topbarItemClick.value = false;
	menuClick.value = false;
	rightMenuClick.value = false;
	userMenuClick.value = false;
}

function onMenuButtonClick(event: Event) {
	menuClick.value = true;
	topbarMenuActive.value = false;
	rightPanelMenuActive.value = false;
	if (layoutMode.value === 'overlay') {
		overlayMenuActive.value = !overlayMenuActive.value;
	}
	if (isDesktop()) staticMenuDesktopInactive.value = !staticMenuDesktopInactive.value;
	else {
		staticMenuMobileActive.value = !staticMenuMobileActive.value;
		if (staticMenuMobileActive.value) {
			blockBodyScroll();
		} else {
			unblockBodyScroll();
		}
	}
	event.preventDefault();
}
function onTopbarMenuButtonClick(event: Event) {
	topbarItemClick.value = true;
	topbarMenuActive.value = !topbarMenuActive.value;
	hideOverlayMenu();
	event.preventDefault();
}
function onTopbarItemClick(event: { originalEvent: Event, item: string }) {
	topbarItemClick.value = true;
	if (activeTopbarItem.value === event.item) activeTopbarItem.value = "null";
	else activeTopbarItem.value = event.item;
	event.originalEvent.preventDefault();
}

function onMenuClick() {
	menuClick.value = true;
}
function onInlineUserClick() {
	userMenuClick.value = true;
	inlineUserMenuActive.value = !inlineUserMenuActive.value;
}
function blockBodyScroll() {
	addClass(document.body, 'blocked-scroll');
}
function unblockBodyScroll() {
	removeClass(document.body, 'blocked-scroll');
}
function onRightMenuButtonClick(event: any) {
	rightMenuClick.value = true;
	rightPanelMenuActive.value = !rightPanelMenuActive.value;
	hideOverlayMenu();
	event.preventDefault();
}
function onRightMenuClick() {
	rightMenuClick.value = true;
}
function hideOverlayMenu() {
	overlayMenuActive.value = false;
	staticMenuMobileActive.value = false;
}
function onMenuItemClick(event: any) {
	if (!event.item.items) {
		$eventBus.$emit('reset-active-index');
		hideOverlayMenu();
		// Abre (ou ativa) a aba da rotina no workspace central.
		if (event.item?.to) {
			tabsStore.abrir(String(event.item.to), event.item.label);
		}
	}
	if (!event.item.items && (isHorizontal() || isSlim())) {
		menuActive.value = false;
	}
}
function onRootMenuItemClick() {
	menuActive.value = !menuActive.value;
}

function isDesktop() {
	if (import.meta.client) {
		return window.innerWidth > 896;
	}
}
function isMobile() {
	if (import.meta.client) {
		return window.innerWidth <= 1025;
	}
}
function isHorizontal() {
	return layoutMode.value === 'horizontal';
}
function isSlim() {
	return layoutMode.value === 'slim';
}
function isMenuVisible() {
	if (isDesktop()) {
		if (layoutMode.value === 'static') return !staticMenuDesktopInactive.value;
		else if (layoutMode.value === 'overlay') return overlayMenuActive.value;
		else return true;
	} else {
		return true;
	}
}
function onLayoutChange(p_layoutMode: any) {
	layoutMode.value = p_layoutMode;
	staticMenuDesktopInactive.value = false;
	overlayMenuActive.value = false;
	if (isSlim() || isHorizontal()) {
		inlineUser.value = false;
		inlineUserMenuActive.value = false;
	}
}
function onMenuColorChange(menuColor: any) {
	lightMenu.value = menuColor;
}
function onProfileModeChange(profileMode: any) {
	inlineUser.value = profileMode;
}
function onChangeOrientation(orientation: any) {
	isRTL.value = orientation;
}
function onTopbarColorChange(p_topbarColor: any, logo: any) {
	topbarColor.value = p_topbarColor;
	const topbarLogoLink: any = document.getElementById('topbar-logo');
	topbarLogoLink.src = '../assets/images/' + logo + '.svg';
}

/**
 * TROCA DE TEMA DESABILITADA PARA PERFORMANCE
 * Apenas theme-blue está carregado no sistema
 * Se precisar reativar, descomente as funções abaixo e remova fonts.css do nuxt.config.ts
 */

// function onThemeChange(p_theme: string) {
// 	theme.value = p_theme;
// 	changeStyleSheetUrl('layout-css', theme.value, 'layout');
// 	changeStyleSheetUrl('theme-css', theme.value, 'theme');
// }
// function changeStyleSheetUrl(id: string, value: string, prefix: string) {
// 	const element: any = document.getElementById(id);
// 	const urlTokens = element.getAttribute('href').split('/');
// 	urlTokens[urlTokens.length - 1] = prefix + '-' + value + '.css';
// 	const newURL = urlTokens.join('/');
// 	replaceLink(element, newURL);
// }
// function replaceLink(linkElement: any, href: any) {
// 	const id = linkElement.getAttribute('id');
// 	const cloneLinkElement = linkElement.cloneNode(true);
// 	cloneLinkElement.setAttribute('href', href);
// 	cloneLinkElement.setAttribute('id', id + '-clone');
// 	linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
// 	cloneLinkElement.addEventListener('load', () => {
// 		linkElement.remove();
// 		cloneLinkElement.setAttribute('id', id);
// 	});
// }
function addClass(element: any, className: string) {
	if (element.classList) element.classList.add(className);
	else element.className += ' ' + className;
}
function removeClass(element: any, className: string) {
	if (element.classList) element.classList.remove(className);
	else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}
const containerClass = computed(() => [
	'layout-wrapper',
	{
		'layout-horizontal': layoutMode.value === 'horizontal',
		'layout-overlay': layoutMode.value === 'overlay',
		'layout-static': layoutMode.value === 'static',
		'layout-slim': layoutMode.value === 'slim',
		'layout-menu-light': lightMenu.value === true,
		'layout-menu-dark': lightMenu.value === false,
		'layout-overlay-active': overlayMenuActive.value,
		'layout-mobile-active': staticMenuMobileActive.value,
		'layout-static-inactive': staticMenuDesktopInactive.value,
		'layout-rtl': isRTL.value,
		'p-input-filled': primeVue.config.inputStyle === 'filled',
		'p-ripple-disabled': primeVue.config.ripple === false,
	},
	topbarColor.value,
]);

</script>

<style scoped>
	/* Cabeçalho do menu lateral: título + recolher. */
	.menu-cabecalho {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem;
		padding: 0.65rem 0.85rem;
		border-bottom: 1px solid color-mix(in srgb, currentColor 12%, transparent);
		position: sticky;
		top: 0;
		z-index: 2;
		background: inherit;
		background-color: var(--surface-card, #fff);
	}

	.menu-cabecalho-titulo {
		font-size: 0.78rem;
		font-weight: 700;
		letter-spacing: 0.06em;
		text-transform: uppercase;
		opacity: 0.7;
	}

	.menu-cabecalho-recolher {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 2rem;
		height: 2rem;
		border: 1px solid color-mix(in srgb, currentColor 16%, transparent);
		border-radius: 8px;
		background: transparent;
		color: inherit;
		cursor: pointer;
		font: inherit;
	}

	.menu-cabecalho-recolher:hover,
	.menu-cabecalho-recolher:focus-visible {
		border-color: #0772b3;
		color: #0772b3;
		background: color-mix(in srgb, #0772b3 8%, transparent);
	}

	/* Campo de pesquisa de rotinas (logo abaixo do cabeçalho do menu). */
	.menu-pesquisa {
		padding: 0.5rem 0.65rem 0.55rem;
		border-bottom: 1px solid color-mix(in srgb, currentColor 12%, transparent);
		background: var(--surface-card, #fff);
		position: sticky;
		top: 0;
		z-index: 1;
	}

	.menu-pesquisa :deep(.r3-input-container) {
		min-width: 0;
		flex: 1 1 auto;
	}

	.menu-pesquisa :deep(.p-inputgroup),
	.menu-pesquisa :deep(.flex.flex-row) {
		width: 100%;
	}

	.menu-pesquisa :deep(.p-inputtext) {
		font-size: 0.85rem;
		padding: 0.45rem 0.55rem;
		width: 100%;
	}

	.menu-pesquisa :deep(.p-button) {
		width: 2.25rem;
		min-width: 2.25rem;
		padding: 0;
	}

	.menu-pesquisa-vazio {
		margin: 0.75rem 0.85rem;
		font-size: 0.82rem;
		opacity: 0.7;
		text-align: center;
	}

	/*
	  Quando o menu está recolhido, um botão fino na borda esquerda
	  permite abrir de novo (sem voltar para o top bar).
	*/
	.menu-toggle-reabrir {
		position: fixed;
		left: 0;
		top: 72px;
		z-index: 1000;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 1.6rem;
		height: 2.75rem;
		padding: 0;
		border: 1px solid color-mix(in srgb, currentColor 16%, transparent);
		border-left: none;
		border-radius: 0 8px 8px 0;
		background: var(--surface-card, #fff);
		color: #0772b3;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		cursor: pointer;
	}

	.menu-toggle-reabrir:hover,
	.menu-toggle-reabrir:focus-visible {
		width: 1.85rem;
		background: color-mix(in srgb, #0772b3 10%, #fff);
	}
</style>
